<template>
  <div class="bancos">
    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
          <b-card header="Listado de Bancos">
            <b-form>
              <b-form-group
                label="Buscar"
                label-for="nombre"
                :label-cols="labelCols"
                horizontal>
                <b-form-input 
                  id="nombre" 
                  v-model="nombre" 
                  class="text-upper"
                  type="text">
                </b-form-input>
              </b-form-group>
            </b-form>

            <b-table hover
                responsive="sm" 
                class="registro"
                :items="bancos" 
                :fields="fields" 
                :filter="nombre"
                :current-page="paginaActual"
                :per-page="registrosPorPagina"
                @filtered="onFiltered"
                @row-clicked="consultar"
                :busy="tableBusy">
              <div slot="table-busy" class="text-center">
                <b-spinner class="table-spinner" label="Spinning" />
              </div>
              <template v-slot:cell(cuentasVirtuales)="data">
                {{ data.item.cuentasVirtuales ? 'Si' : 'No' }}
              </template>
              <template v-slot:cell(opciones)="data">
                <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                  <template slot="button-content">
                    <i class="fa fa-ellipsis-v"></i>
                  </template>
                  <b-dropdown-item @click.stop="editarItem(data.item)">
                    <i class="fa fa-edit"></i>Editar Datos del Banco</b-dropdown-item>
                </b-dropdown>
              </template>            
            </b-table>
            <nav>
              <b-pagination size="sm" 
                :total-rows="totalRegistros" 
                :per-page="registrosPorPagina" 
                v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
            </nav>
          </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item @click.stop="agregar">
            <i class="fa fa-plus"></i>Nuevo Banco</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'bancos/getField',
  mutationType: 'bancos/updateField',
});

export default {
  name: 'BancosList',
  components: {
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal,
  ],
  data: () => {
    return {
      fields: [
        { key: 'nombre' },
        { 
          key: 'cuentasVirtuales',
          label: 'Billetera/Plataforma',
          class: 'text-center'
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      tableBusy: false,
      labelCols: 1
    }
  },
  computed: {
    ...mapFields([
      'bancos',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
      'nombre'
    ]),
  },
  created() {
    this.getItems();
  },  
  methods: {
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('bancos/getBancos')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    agregar () {
      this.$router.push({ name: 'BancoAdd' });
    },
    editarItem (item) {
      this.$router.push({ name: 'BancoEdit', 
                          params: { 
                            id: item.id 
                          }});
    },
    consultar (item) {
      this.$router.push({ name: 'BancoDatos', 
                          params: { 
                            id: item.id 
                          }});
    },
    onFiltered(filteredItems) {
      this.totalRegistros = filteredItems.length
      this.paginaActual = 1
    },
  },
}
</script>

<style>
  .bancos .registro table td[aria-colindex="1"] {
    width: calc(90% - 30px);
  }
  .bancos .registro table td[aria-colindex="2"] {
    width: 10%;
  }
  .bancos .registro table td[aria-colindex="3"] {
    width: 30px;
  }
</style>
